<template>
  <el-form-item label="标题">
    <el-switch v-model="prop.titleShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="标题" size="small">
    <div class="flex">
      <el-input v-model="prop.title"></el-input>
      <BindModel :linkData="prop.linkData" show-loop v-model:bindParam="prop.titleBindParam" showPageParam></BindModel>
    </div>
  </el-form-item>
  <el-form-item label="字体颜色">
    <colorPicker v-model="prop.titleColor"></colorPicker>
  </el-form-item>
  <el-form-item label="字体大小">
    <el-input-number v-model="prop.titleFontSize" size="small" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="字体位置">
    <el-select v-model="prop.titlePosition" size="small">
      <el-option v-for="item in dicOption.textAlign" :key="item.value" :label="item.label"
                 :value="item.value"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="副标题">
    <el-input v-model="prop.subtext" size="small"></el-input>
  </el-form-item>
  <el-form-item label="字体颜色">
    <colorPicker v-model="prop.subTitleColor"></colorPicker>
  </el-form-item>
  <el-form-item label="字体大小">
    <el-input-number v-model="prop.subTitleFontSize" size="small" controls-position="right"></el-input-number>
  </el-form-item>
</template>
<script setup>
import {dicOption} from "@/option/config";
import BindModel from "@/option/components/dataCenter/bindModel.vue";
import colorPicker from "./color-picker.vue";

let props = defineProps({
  prop: {
    linkData: {},
  },
});
</script>
<style scoped></style>